import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import {
  cegidIntegrationRejectionCodeToTooltipTranslationKeys,
  cegidIntegrationRejectionCodeToTranslationKeys,
  cegidIntegrationStatusToTranslationKeys,
} from '@features/cegidIntegration/constants/cegidIntegrationStatusToTranslationKeys'
import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'

export const useBillIntegrationStatusMessageKey = (integrationStatus?: IntegrationStatus): null | string => {
  if (!integrationStatus) {
    return null
  }

  const { status, rejectCode } = integrationStatus

  let messageKey: string | null = null
  if (status === CegidIntegrationStatus.Failed && rejectCode) {
    messageKey =
      cegidIntegrationRejectionCodeToTranslationKeys[rejectCode] ?? cegidIntegrationStatusToTranslationKeys.rejected
  }

  return messageKey
}

export const useBillIntegrationStatusTooltipMessageKey = (integrationStatus?: IntegrationStatus): null | string => {
  if (!integrationStatus) {
    return null
  }

  const { status, rejectCode } = integrationStatus
  let tooltipTKey: string | null = cegidIntegrationStatusToTranslationKeys[status]

  if (status === CegidIntegrationStatus.Failed && rejectCode) {
    tooltipTKey =
      cegidIntegrationRejectionCodeToTooltipTranslationKeys[rejectCode] ??
      cegidIntegrationStatusToTranslationKeys.rejected
  }

  return tooltipTKey
}
